
// STATE
export const STATE = "/states";

// REGION
export const REGION = "/regions";

// PROPERTY
export const PROPERTY = "/properties/all";
export const PROPERTY_DETAIL = "/properties/detail";
export const PROPERTY_LOCATIONS = "/properties/locations";
export const PROPERTY_CREATE = "/properties/add-property";

// FACILITY
export const FACILITY = "/facilities";

// FACILITY_GROUP
export const FACILITY_GROUP = "/facilityGroups";

// FLOORING
export const FLOORING = "/flooring";

// CABINET
export const CABINET = "/cabinets";

// DOCUMENT
export const DOCUMENT = "/documents";

// ADVISOR
export const ADVISOR = "/advisors";
export const ADVISOR_TOP = "/advisors/top";
export const ADVISOR_CONTACT = "/advisorContacts";

// FILE
export const FILE_BY_UUID = "files";

// PAGE
export const PAGE = "/pages/byKey";

// ANNOUNCEMENT
export const ANNOUNCEMENT = "/announcements";